import { format, isValid, isAfter, startOfDay, endOfDay } from 'date-fns';

export const validateOutcomes = (outcomes) => {
    let errors = '';
    if (outcomes && outcomes.length > 0) {
        const noOrder = outcomes.filter((o) => !o.listOrder);
        if (noOrder && noOrder.length > 0) errors = 'All logging outcomes must have a list order';
        const noDesc = outcomes.filter((o) => !o.reasonDescription);
        if (noDesc && noDesc.length > 0) errors += `${errors ? '; ' : ''}All logging outcomes must contain a reason description`;
    }
    return errors;
}

export const updateEntry = (entryIn, form) => {
    let entryOut = JSON.parse(JSON.stringify(entryIn));
    if (form.callerFirstName && entryIn.callerFirstName !== form.callerFirstName) entryOut = {
        ...entryOut,
        callerFirstName: form.callerFirstName
    };
    if (form.callerLastName && entryIn.callerLastName !== form.callerLastName) entryOut = {
        ...entryOut,
        callerLastName: form.callerLastName
    };
    if (form.comments) entryOut = {...entryOut, comments: form.comments};
    return entryOut;
}

export const validateLogEntry = (logEntry) => {
    let errors = '';
    if (!logEntry.callerFirstName || !logEntry.callerLastName) errors = 'A first and last name are required';
    if (!logEntry.outcome) {
        errors += `${errors.length > 1 ? '; ' : ''}You must enter an outcome`;
    } else if (logEntry.outcome === 'N/A' && !logEntry.outcomeReason) errors += `${errors.length > 1 ? '; ' : ''}If the outcome is "N/A, you must enter a reason"`;
    return errors;
}

export const validateReport = (startDate, endDate) => {
    let errors = '';
    if (!isValid(startDate) || isAfter(startDate, endOfDay(new Date()))) errors = 'Invalid start date';
    if (!isValid(endDate)) errors += `${errors ? '; ' : ''}Invalid end date`;
    return errors;
}

export const getReportRequest = (form, startDate, endDate) => {
    const startVal = format(startOfDay(startDate), "yyyy-MM-dd'T'HH:mm:ss'.'SSS");
    const endVal = format(endOfDay(endDate), "yyyy-MM-dd'T'HH:mm:ss'.'SSS");
    const userId = form.reportUser ? form.reportUser : null;
    return {userId: userId, startDate: startVal, endDate: endVal};
}